module.exports = __webpack_public_path__ + "media/images/home-page/1-4@2x-5b7269584b6164f902263091be6e2fc4.png";